// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2rbI-","paramInput":"JobSimulator_paramInput__1ubNe","input":"JobSimulator_input__FezNQ"};